export default "__VITE_ASSET__PJkk5Ocr__"